export default String.raw`
.blog-container {
    $cgap: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1130px + 2 * $cgap;
    margin: 0 auto 70px auto;
    @include body-1-regular;

    &__title {
        align-self: start;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        column-gap: 18px;
        row-gap: 10px;
        margin-bottom: 40px;
    }

    ul {
        align-self: start;
    }

    &__list {
        $columns-width: calc((100% - (2 * $cgap)) / 3);
        display: grid;
        grid-template-columns: repeat(3, $columns-width);
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        row-gap: 24px;
        column-gap: $cgap;
    }

    .selected-filters {
        &__item {
            width: fit-content;
            height: 32px;
            display: flex;
            align-items: center;

            svg {
                width: 20px;
                height: 20px;

                &:hover {
                    fill: $iconColorsHover;
                }
            }
        }
    }
}
`